module.exports = __webpack_public_path__ + "media/assets/images/lib/content-tools/ce-drop-below-7fa15807226f773985179ad0ca920349.png";